import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApiError } from '../../lib/api.js'
import { saveEphemeralSession } from '../../lib/ephemeral-session.js'
import { SUBMIT_ERROR_FALLBACK, toUserMessage } from '../../lib/error-copy.js'
import { getVisitorId } from '../../lib/fingerprint.js'
import { initializeHook } from '../../lib/hook-api.js'

/**
 * 公開トップの「無料で試す」導線。
 * Fingerprint → /hook/initialize → 暫定セッション保存 → /projects。
 */
export function useTryFree() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [migratedNotice, setMigratedNotice] = useState(false)

  const onTryFree = async () => {
    setLoading(true)
    setError(null)
    setMigratedNotice(false)
    try {
      const visitorId = await getVisitorId()
      const out = await initializeHook({ visitorId })
      saveEphemeralSession(out)
      navigate('/projects')
    } catch (err) {
      if (err instanceof ApiError && err.code === 'ACCOUNT_MIGRATED') {
        setMigratedNotice(true)
      } else {
        setError(toUserMessage(err, SUBMIT_ERROR_FALLBACK))
      }
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, migratedNotice, onTryFree }
}
